export default function getDatesDiff(date2, date1) {
  return (
    (date2 && date1 && new Date(date2).getTime() - new Date(date1).getTime()) /
    (1000 * 60 * 60 * 24)
  )
}
